import { Utils } from 'cc-common';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { Type } from 'class-transformer';

export class WorkflowHistoryResultDto {
    id: number;
    beginStep: string;
    userAction: string;

    @Type(() => UserNameDisplayResultDto)
    user: UserNameDisplayResultDto; // 	NOTE: For now use DisplayName property in the UI

    @Type(() => Date)
    actionedOn: Date;
    additionalInfo: string;

    get userNameDisplayText(): string {
        return Utils.notNullAndDefined(this.user) ? this.user.displayName : null;
    }
}
